export enum ValidationError {
    NoIssue,
    NoURLEntered,
    InvalidURLEntered,
    IncorrectUrl,
    InProgressBatchExist,
    TechnicalIssue,
}

export enum UrlType {
    BCom,
    Airbnb,
}

export enum PropertyType {
    Unknown = -1,
    HOME = 1,
    HOTEL_AND_MORE = 2,
}
